import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        thumbnailImageItem: {
            borderRadius: 'none',
            display: 'block',
            height: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
            width: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
        },
    },
    variants: {
        colorThumbnail: {
            thumbnailImageItem: {
                boxSizing: 'content-box',
                height: remCalc(80),
                width: remCalc(80),
                _hover: {
                    borderWidth: remCalc(2),
                    borderColor: 'border.dark',
                },
            },
        },
    },
}
